import {
  ANT_SOLICITAR_START,
  ANT_GETLISTADO_START,
} from "../../const/actionTypes";

export const GetAnticipos = (payload) => ({
  type: ANT_GETLISTADO_START,
  payload,
});
export const Solicitar = (payload) => ({
  type: ANT_SOLICITAR_START,
  payload,
});
